import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { BannerManagementModule } from '@/modules/banner-management';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const bannerManagementSearchSchema = z.object({
  bannerType: z
    .enum(['ALL', 'HOME', 'WALLET', 'FANTASY', 'SHOPPING', 'OPINION_TRADING'])
    .default('ALL'),
  status: z.enum(['ALL', 'ACTIVE', 'HIDDEN', 'EXPIRED']).default('ALL'),
  search: z.string().default(''),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(10),
});

export const Route = createFileRoute('/dashboard/banner-management/')({
  validateSearch: bannerManagementSearchSchema,
  component: BannerManagementPage,
});

function BannerManagementPage() {
  const { canAccessBannerManagement } = useAccessControl();
  if (!canAccessBannerManagement) {
    return <AccessDenied />;
  }
  return <BannerManagementModule />;
}
